import { useTranslations } from '@/i18n/context';

export function Story() {
  const t = useTranslations('story');
  const milestones = [
    { n: '2018', l: t('milestones.founded') },
    { n: '30W+', l: t('milestones.families') },
    { n: '99%', l: t('milestones.rating') },
    { n: t('milestones.returnsShort'), l: t('milestones.returns') },
    { n: t('milestones.responseShort'), l: t('milestones.response') },
    { n: t('milestones.allBreedsShort'), l: t('milestones.allBreeds') },
  ];

  return (
    <section
      id="story"
      className="relative bg-[color:var(--mp-cream)] py-24 md:py-40"
    >
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-12 px-6 md:grid-cols-12 md:gap-16 md:px-12 lg:px-20">
        <div className="md:col-span-4">
          <div className="sticky top-32">
            <div className="mb-6 text-[11px] uppercase tracking-[0.32em] text-[color:var(--mp-moss)]">
              {t('sectionLabel')}
            </div>
            <h2
              className="font-serif-cn text-4xl leading-[1.25] text-[color:var(--mp-forest)] md:text-5xl"
              // eslint-disable-next-line react/no-danger -- trusted translation
              dangerouslySetInnerHTML={{ __html: t('title') }}
            />
          </div>
        </div>

        <div className="md:col-span-7 md:col-start-6">
          <div className="space-y-8 font-serif-cn text-[17px] leading-[2] text-[color:var(--mp-forest)]/85 md:text-lg">
            <p
              // eslint-disable-next-line react/no-danger -- trusted translation
              dangerouslySetInnerHTML={{ __html: t('p1') }}
            />
            <p>{t('p2')}</p>
            <p>{t('p3')}</p>
          </div>

          <div className="mt-14 grid grid-cols-2 gap-x-8 gap-y-10 border-t hairline pt-10 md:grid-cols-3">
            {milestones.map((s) => (
              <div key={s.l}>
                <div className="font-display text-3xl text-[color:var(--mp-forest)]">
                  {s.n}
                </div>
                <div className="mt-1 text-[11px] uppercase tracking-[0.2em] text-[color:var(--mp-forest)]/60">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
